<template>
  <div class="cpnt-arm-arq-icone">
    <!-- SETA A MASCARA -->
    <div class="mascara-geral" v-if="mascara === true">
      <RF-Status-2 :cpntStatus='"carregando"' :cpntTamanho='5'></RF-Status-2>
    </div>

    <!-- ADCIONA A MASCARA CARREGANDO -->
    <div class="mascara" v-if="statusGeral === 'carregando'" :key="'ven-editar-anexos-bt--' + cpntId">
      <RF-Status-2 :cpntStatus='statusGeral'></RF-Status-2>
    </div>

    <template v-else-if="tpFile === 'audio'">
      <div class="vac-audio-message">
        <div id="vac-player">
          <audio controls="controls" style="max-width: 100%;"><source :src="thumbnailB64"/></audio>
        </div>
      </div>
    </template>

    <!-- ADICIONA O BUTTON -->
    <RF-Button :key="time" class="botao" v-else
    :cpntId="'cpnt-arm-arquivo-file-icone--' + cpntId"
    :cpntStatus='statusGeral === "carregando" ? "" : statusGeral'
    :cpntClass='cpntClass'
    @onClickButton='armArquivoFileIconeAbrir'>
    <template slot="conteudo">
      <template v-if="[ '', null, undefined ].indexOf(thumbnailB64) === -1">
        <img :src="'data:image/' + cpntFileExt + ';base64, ' + thumbnailB64" :alt="cpntFileName" ref="imagem" :title="cpntFileName" @load="armArquivoFileIconeCalcularTamanho('')" />
      </template>
      <template v-else-if="tpFile === 'pdf'">
        <img src="/img/icones/pdf.png" :alt="cpntFileName" :title="cpntFileName"/>
      </template>
      <template v-else-if="tpFile === 'imagem'">
        <img src="/img/icones/imagem.png" :alt="cpntFileName" :title="cpntFileName"/>
      </template>
      <template v-else-if="tpFile === 'word'">
        <img src="/img/icones/word.png" :alt="cpntFileName" :title="cpntFileName"/>
      </template>
      <template v-else-if="tpFile === 'excel'">
        <img src="/img/icones/excel.png" :alt="cpntFileName" :title="cpntFileName"/>
      </template>
      <template v-else-if="tpFile === 'zip'">
        <img src="/img/icones/zip.png" :alt="cpntFileName" :title="cpntFileName"/>
      </template>
      
      <template v-else>
        <img src="/img/icones/file.png" :alt="cpntFileName" :title="cpntFileName"/>
      </template>
    </template>
    </RF-Button>

    <!-- CRIA O BOTÃO PARA EXCLUIR A IMAGEM -->
    <RF-Button :data-time="time" class="remover-file" v-if="Object.keys(excluir).length >= 1"
      :cpntId="excluir.id"
      :cpntStatus='excluir.status'
      :cpntTipo='excluir.tipo'
      :cpntIcone='excluir.icone'
      :cpntClass='excluir.class'

      @onClickButton='excluir.onClick'>
    </RF-Button>

    <!-- CRIA O BOTÃO PARA EXCLUIR A IMAGEM -->
    <RF-Button :data-time="time" class="copiar-file" v-if="Object.keys(copiar).length >= 1"
      :cpntId="copiar.id"
      :cpntStatus='copiar.status'
      :cpntTipo='copiar.tipo'
      :cpntIcone='copiar.icone'
      :cpntClass='copiar.class'

      @onClickButton='copiar.onClick'>
    </RF-Button>

    <!-- ADICIONA O NOME DO ARQUIVO -->
    <div :key="'nome-' + cpntId" v-html="cpntFileName" v-show="cpntFileNameMostrar" @click='armArquivoFileIconeAbrir'></div>
    
    <!-- VERIFICA SE DEVE MOSTRAR A IMAGEM -->
    <template v-if="mostrarImage === true">
      <!-- DOCUMENTAÇÃO DA BIBLIOTECA https://github.com/XiongAmao/vue-easy-lightbox -->
      <vue-easy-lightbox
        :escDisabled="cpntEscDisabled"
        :moveDisabled="cpntMoveDisabled"
        :visible="mostrarImage"
        :imgs="conteudoB64"
        @hide="armArquivoFileIconeAbrirVisualizacao"
      ></vue-easy-lightbox>
    </template>
  </div>
</template>

<style scoped>
  .cpnt-arm-arq-icone {
    padding-left: 10px;
    width: 130px;
    min-width: 130px;
    max-width: 130px;
    word-break: break-word;
  }
    .cpnt-arm-arq-icone {
      display: inline-block;
      position: relative;
      margin: 5px;
      padding-top: 5px;
      text-align: center;
      vertical-align: top;
    }
      .cpnt-arm-arq-icone > .mascara-geral {
        width: calc(100% + 10px);
        height: 100%;
        background: rgba(0, 0, 0, 0.28);
        position: fixed;
        top: 0px;
        left: -10px;
        z-index: 2700;
        color: #fff;
        padding-top: 25%;
      }
      .cpnt-arm-arq-icone > .mascara {
        background: rgba(0, 0, 0, 0.10);
        color: #fff;
        cursor: no-drop;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 3px;
      }
      .cpnt-arm-arq-icone > .botao {
        padding: 5px;
        width: 65px;
        min-width: 65px;
        max-width: 65px;
        height: 65px;
        border-color: #e9e9e9;
      }
</style>

<style>
  .cpnt-arm-arq-icone > .botao ~ .remover-file {
    display: none;
    position: absolute;
    right: 10%;
    top: 0px;
    margin-bottom: 5px;
    border-color: #e9e9e9;
    padding: 3px 5px;
  }
    .cpnt-arm-arq-icone:hover > .botao ~ .remover-file {
      display: block;
    }

  .cpnt-arm-arq-icone > .botao ~ .copiar-file {
    display: none;
    position: absolute;
    right: 10%;
    top: 22px;
    margin-bottom: 5px;
    border-color: #e9e9e9;
    padding: 3px 4px;
  }
    .cpnt-arm-arq-icone:hover > .botao ~ .copiar-file {
      display: block;
    }
  .cpnt-arm-arq-icone > .botao > img {
    border-radius: 3px;
    max-width: 100px;
  }
  .cpnt-arm-arq-icone > .mascara > div {
    padding: 30px 0px;
  }
    .cpnt-arm-arq-icone > .mascara-geral > div > div > div,
    .cpnt-arm-arq-icone > .mascara > div > div > div {
      background: #fff !important;
    }
  .cpnt-arm-arq-icone > .vel-modal {
    z-index: 99999 !important;
    /*top: 67px !important;*/
  }
</style>

<script>
export default {
  props: {
    cpntId: {
      required: true
    },
    cpntFileName: {
      required: true,
      type: String
    },
    cpntFileNameMostrar: {
      required: false,
      type: Boolean,
      default: function () {
        return true
      }
    },
    cpntParams: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntFileExt: {
      required: true,
      type: String
    },
    cpntFileSizeThumbnail: {
      required: true
    },
    cpntThumbnail: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntClass: {
      required: false,
      default: function () {
        return [ 'btn', 'btn-default', 'btn-sm' ]
      }
    },
    cpntToken: {
      required: false,
      type: String,
      default: function () {
        return null
      }
    },
    cpntMineType: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntConteudo: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntAbrirArquivo: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntMoveDisabled: {
      required: false,
      default: function () {
        return false
      }
    },
    cpntEscDisabled: {
      required: false,
      default: function () {
        return false
      }
    },
    cpntDeleteArquivo: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntCopiarArquivo: {
      required: false,
      default: function () {
        return null
      }
    },

    cpntLightboxTipo: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntLightboxId: {
      required: false,
      default: function () {
        return null
      }
    }
  },
  components: {
    'RF-Status-2': () => import('@/components/rf-geral/status/RF-Status-2.vue'),
    'lightbox': () => import('vue-my-photos'),
    'vue-easy-lightbox': () => import('vue-easy-lightbox')
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      thumbnailB64: '',
      conteudoB64: [],
      tpFile: '',
      mostrarImage: false,
      excluir: {},
      copiar: {},
      mascara: false
    }
  },
  mounted: function () {
    this.armArquivoFileIconeIniciar()
  },
  methods: {
    armArquivoFileIconeIniciar: function () {
      // CHAMA A FUNÇÃO PARA SETAR O STATUS
      this.armArquivoFileIconeSetarStatusGeral('carregando')

      // SETA O BOTÃO DE EXCLUIR
      if ((this.$route.name === 'file_qrcode' || this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 30 ], null, [ 54 ], null, [ 572 ], null, false) === true) && [ '', null, undefined ].indexOf(this.cpntDeleteArquivo) === -1) {
        this.excluir = {
          status: '',
          id: 'cpnt-arm-arquivo-file-icone-excluir--' + this.cpntId,
          tipo: 'icone',
          icone: { tipo: 'cancelar' },
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          onClick: this.armArquivoFileIconeDeletar
        }
      }

      // SETA O BOTÃO DE EXCLUIR
      if ([ '', null, undefined ].indexOf(this.cpntCopiarArquivo) === -1) {
        this.copiar = {
          status: '',
          id: 'cpnt-arm-arquivo-file-icone-copiar--' + this.cpntId,
          tipo: 'icone',
          icone: { tipo: 'copiar' },
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          onClick: this.armArquivoFileIconeCopiar
        }
      }

      // VERIFICA O TIPO DE ARQUIVO
      switch (this.cpntFileExt) {
        case 'pdf':
          this.tpFile = 'pdf'
          break

        case 'csv':
        case 'xls':
        case 'xlsx':
          this.tpFile = 'excel'
          break

        case 'doc':
        case 'docx':
          this.tpFile = 'word'
          break

        case 'zip':
        case 'rar':
          this.tpFile = 'zip'
          break

        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
          this.tpFile = 'imagem'
          break

        case 'ogg':
        case 'mp3':
          this.tpFile = 'audio'
          break

        default:
          this.tpFile = 'arquivo'
          break
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
      
      // VERIFICA SE TEM THUMBNAIL
      if (Number(this.cpntFileSizeThumbnail) <= 0 || this.cpntThumbnail !== null) {
        // SETA O ICONE RECEBIDO
        if ([ '', null, undefined ].indexOf(this.cpntThumbnail) === -1) {
          this.armArquivoFileIconeSetarThumbnail(this.cpntThumbnail)
        }

        // SETA O STATUS
        this.armArquivoFileIconeSetarStatusGeral('')
      } else {
        this.armArquivoFileIconeBuscarArquivo('thumbnail_b64', (dados) => {
          // SETA O THUMBNAIL RECEBIDO
          this.armArquivoFileIconeSetarThumbnail(dados.thumbnail_b64)

          // REMOVE O STATUS GERAL DO BUTTON
          this.armArquivoFileIconeSetarStatusGeral('')
        })
      }
    },
    armArquivoFileIconeSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArquivoFileIconeBuscarArquivo: function (tipo, callback) {
      var self = this

      // INICIA O QUERYGET
      var queryGet = {}

      // SETA OS VALORES SOLICITADOS
      queryGet.lot = typeof tipo === 'string' ? [ { id: self.cpntId, tipo: [ tipo ] } ] : tipo

      // FAZ A BUSCA NA API
      self.$store.state.comunicaAPI('/arm-arquivo/arquivo/get/', 'GET', queryGet, function (apiSuccess) {
        // PEGA OS RETORNOS QUE DEU OK
        var retOK = apiSuccess.lot.filter(item => item.code === '200')
        
        // PEGA OS RETORNOS QUE DEU ERRO
        var retErro = apiSuccess.lot.filter(item => item.code !== '200')

        // APRESENTA O ERRO RECEBIDO
        if (retErro.length >= 1) {
          self.$store.state.TRATAR_RET_LOT_API(retErro)
        }

        // PEGA O RETORNO RECEBIDO
        if (retOK.length >= 1) {
          // ORGANIZA O RETORNO COMO ESPERADO
          if (typeof tipo === 'string') {
            retOK = retOK[0].data
          }

          // FINALIZA O CARREGAMENTO
          callback(retOK)
        }

        // // VERIFICA SE DEU ERRO NA SOLICITAÇÃO
        // switch (apiSuccess.lot[0].code) {
        //   case '200':
        //     callback(apiSuccess.lot[0].data)
        //     break

        //   default:
        //     self.$store.state.msgWarn('API [' + apiSuccess.lot[0].code + ']: ' + apiSuccess.lot[0].message, 'danger')
        //     break
        // }
      }, self.armArquivoFileIconeSetarStatusGeral, null, self.cpntToken)
    },
    armArquivoFileIconeAbrir: function () {
      var self = this

      // SETA A MASCARA NA TELA DO CLIENTE
      self.mascara = true

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      self.time = new Date().getTime()

      // VERIFICA A AÇÃO QUE DEVE SER FEITA
      switch (self.tpFile) {
        case 'imagem':
          if ([ '', null, undefined ].indexOf(self.cpntConteudo) === -1) {
            // SETA O ARQUIVO RECEBIDO
            self.armArquivoFileIconeSetarConteudo(self.cpntConteudo)

            // CHAMA A FUNÇÃO PARA ABRIR O ARQUIVO
            self.armArquivoFileIconeAbrirVisualizacao()
          } else if ([ '', null, undefined ].indexOf(self.cpntAbrirArquivo) !== -1) {
            if (Object.keys(self.conteudoB64).length === 0) {
              if (self.cpntLightboxTipo !== null && self.cpntLightboxId !== null) {
                // INICIA O QUERYGET
                var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, filename: null, ext: null, size_bytes_thumbnail: null, posicao: null, last_at: null }, order: {} }

                // SETA O WHERE
                queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: self.cpntLightboxTipo, o: '=', v: self.cpntLightboxId } ] }

                // PEGA APENAS ARQUIVOS QUE NÃO SÃO INTERNOS
                queryGet.where.aAnd.push({ f: 'interno', o: '=', v: 'n' })

                // SETA A ORDENAÇÃO
                queryGet.order = { posicao: 'asc', last_at: 'asc' }

                // FAZ A BUSCA NA API
                self.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, (retorno) => {
                  // INICIA A VARIAVEL
                  var busca = []

                  // RODA O VETOR MONTANDO OS VALORES PARA BUSCA
                  for (var index in retorno.data) {
                    busca.push(JSON.parse(JSON.stringify({ id: retorno.data[index].id, tipo: ['link_download'] })))
                  }

                  // BUSCA O CONTEUDO DOS ARQUIVOS
                  self.armArquivoFileIconeBuscarArquivo(busca, (retorno2) => {
                    // ADICIONA OS ARQUIVOS RECEBIDOS
                    for (var indexR in retorno2) {
                      self.armArquivoFileIconeSetarConteudo(retorno2[indexR].data, (indexR === 0))
                    }

                    // CHAMA A FUNÇÃO PARA ABRIR O ARQUIVO
                    self.armArquivoFileIconeAbrirVisualizacao()
                  })
                }, self.armArquivoFileIconeSetarStatusGeral)
              } else {
                self.armArquivoFileIconeBuscarArquivo('link_download', function (retorno) {
                  // VERIFICA O TIPO DE REGISTRO RECEBIDO
                  var conteudo = ([ '', null, undefined ].indexOf(retorno.conteudo_b64) === -1 ? retorno.conteudo_b64 : ([ '', null, undefined ].indexOf(retorno.link_download) === -1 ? retorno.link_download : ''))
  
                  // SETA O ARQUIVO RECEBIDO
                  self.armArquivoFileIconeSetarConteudo(conteudo)
  
                  // CHAMA A FUNÇÃO PARA ABRIR O ARQUIVO
                  self.armArquivoFileIconeAbrirVisualizacao()
                })
              }
            } else {
              self.armArquivoFileIconeAbrirVisualizacao()
            }
          } else if ([ '', null, undefined ].indexOf(self.cpntAbrirArquivo) === -1) {
            // CHAMA A FUNÇÃO PARA ABRIR
            self.cpntAbrirArquivo(self.cpntId)

            // SETA A MASCARA NA TELA DO CLIENTE
            self.mascara = false

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }
          break

        default:
          if ([ '', null, undefined ].indexOf(self.cpntConteudo) === -1) {
            // INICIA O BOTÃO PARA FAZER O DONWLOAD
            var botao = document.createElement('a')

            // SETA O CONTEUDO QUE SERÁ BAIXADO
            var conteudo = self.cpntConteudo

            conteudo = 'data:' + self.cpntMineType + ';base64, ' + encodeURIComponent(conteudo)

            // ADICIONA O CONTEUDO DO ARQUIVO
            botao.setAttribute('href', conteudo)

            // SETA O NOME DO ARQUIVO QUE DEVE BAIXAR
            botao.setAttribute('download', self.cpntFileName)

            // DEIXA O BOTÃO OCULTO, PARA NÃO APARECER PARA O CLIENTE
            botao.style.display = 'none';

            // ADICIONA O BOTÃO NA TELA
            document.body.appendChild(botao)

            // REALIZA O CLICK NO BOTÃO
            botao.click()

            // // REMOVE O BOTÃO DA TELA
            // document.body.removeChild(botao)

            // SETA A MASCARA NA TELA DO CLIENTE
            self.mascara = false

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          } else {
            self.armArquivoFileIconeBuscarArquivo('link_download', function (retorno) {
              // ABRE O DOCUMENTO INFORMADO
              window.open(retorno.link_download, '_blank')

              // SETA A MASCARA NA TELA DO CLIENTE
              self.mascara = false
            })
          }
          break
      }
    },
    armArquivoFileIconeDeletar: function () {
      // CHAMA A FUNÇÃO PARA SETAR O STATUS
      this.armArquivoFileIconeSetarStatusGeral('carregando')

      // CHAMA A FUNÇÃO PARA DELETAR O ARQUIVO
      this.cpntDeleteArquivo([ '', null, undefined ].indexOf(this.cpntParams) === -1 ? this.cpntParams : this.cpntId)
    },
    armArquivoFileIconeCopiar: function () {
      // // CHAMA A FUNÇÃO PARA SETAR O STATUS
      // this.armArquivoFileIconeSetarStatusGeral('carregando')

      // CHAMA A FUNÇÃO PARA DELETAR O ARQUIVO
      this.cpntCopiarArquivo([ '', null, undefined ].indexOf(this.cpntParams) === -1 ? this.cpntParams : this.cpntId)
    },
    armArquivoFileIconeAbrirVisualizacao: function () {
      // SETA O NOVO VALOR RECEBIDO
      this.mostrarImage = !this.mostrarImage

      // SETA A MASCARA NA TELA DO CLIENTE
      this.mascara = false

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // // VERIFICA SE DEVE ABRIR OU NÃO A IMAGEM
      // if (this.mostrarImage === true) {
      //   this.armArquivoFileIconeAbrirVisualizacaoLightbox(this)
      // }
    },
    // armArquivoFileIconeAbrirVisualizacaoLightbox: function(self, tentativa = 0) {
    //   if (tentativa <= 10) {
    //     if ([ '', null, undefined ].indexOf(self.$refs) === -1 && [ '', null, undefined ].indexOf(self.$refs.lightbox) === -1 && [ '', null, undefined ].indexOf(self.$refs.lightbox.show) === -1) {
    //       // ABRE O PLUGIN LIGHTBOX
    //       self.$refs.lightbox.show(self.conteudoB64.name)

    //       // AGUARDAR PARA REMOVER A MASCARA
    //       setTimeout(function () {
    //         // SETA A MASCARA NA TELA DO CLIENTE
    //         self.mascara = false

    //         // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
    //         self.time = new Date().getTime()
    //       }, 500)
    //     } else {
    //       setTimeout(function () { self.armArquivoFileIconeAbrirVisualizacaoLightbox(self, tentativa + 1) }, 500)
    //     }
    //   }
    // },
    armArquivoFileIconeSetarThumbnail: function (valor) {
      // SETA O NOVO VALOR RECEBIDO
      this.thumbnailB64 = valor

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArquivoFileIconeSetarConteudo: function (valor, limpar = true) {
      // PEGA O LINK DE DOWNLOAD
      var link = typeof valor === 'string' ? valor : valor.link_download

      // PEGA A EXTENSÃO DO ARQUIVO
      var ext = typeof valor === 'string' ? this.cpntFileExt : valor.ext

      // PEGA O NOME DO ARQUIVO
      var filename = typeof valor === 'string' ? this.cpntFileName : valor.filename

      // VERIFICA O VALOR QUE DEVE INSERIR
      link = ((link.indexOf('https://') !== -1 || link.indexOf('http://') !== -1) ? link : 'data:image/' + ext + ';base64, ' + link + '')

      // LIMPA O VETOR
      if (limpar === true) {
        this.conteudoB64 = []
      }

      // ADICIONA O VALOR RECEBIDO
      this.conteudoB64.push({ title: filename, src: link })

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArquivoFileIconeCalcularTamanho: function () {
      if ([ '', null, undefined ].indexOf(this.$refs.imagem) === -1) {
        // CARREGA OS VALORES
        var x = 50
        var y = 50
        
        // PEGA O TAMANHO DAS IMAGENS
        var imageWidth = this.$refs.imagem.width
        var imageHeight = this.$refs.imagem.height
        
        // CALCULA OS TAMANHOS PROPORCIONAIS
        if (imageHeight > y) {
          imageWidth = imageWidth * (y / imageHeight)
          imageHeight = y
  
          if (imageWidth > x) {
            imageHeight = imageHeight * (x / imageWidth)
            imageWidth = x
          }
        } else if (imageWidth > x) {
          imageHeight = imageHeight * (x / imageWidth)
          imageWidth = x
  
          if (imageHeight > y) {
            imageWidth = imageWidth * (y / imageHeight)
            imageHeight = y
          }
        }
        
        // SETA OS TAMANHOS CALCULADOS
        this.$refs.imagem.style.width = imageWidth
        this.$refs.imagem.style.height = imageHeight
      }
    }
  },
  watch: {
    cpntFileName: function () {
      this.armArquivoFileIconeIniciar()
    },
    cpntThumbnail: function () {
      this.armArquivoFileIconeSetarThumbnail(this.cpntThumbnail)
    }
  }
}
</script>
